import { Autocomplete, Box, Chip, Grid, InputAdornment, MenuItem, OutlinedInput, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import useApiRequest from '../services/apiRequest';import { GlobalStateContext } from '../wrappers/GlobalContext';
import AssistedSearch from './AssistedSearch';
import { AccountCircle, Add } from '@mui/icons-material';

type Props = {
    facet: string
}
function SearchFacetInput({ facet }: Props) {
    const { queryStringConverter} = useApiRequest();
    const [typedFacet, setTypedFacet] = useState("");

    const { description, filters, searchType: search_type, setFilters, cleanFilters } = useContext(GlobalStateContext);

    const { searchType, setSearchType } = useContext(GlobalStateContext);
    const { typedSearchType, setTypedSearchType } = useContext(GlobalStateContext);
    const { selectedFacets, setSelectedFacets } = useContext(GlobalStateContext);
    const { selectedRowsFacet, setSelectedRowsFacet } = useContext(GlobalStateContext);




    const [searchFacet, setSearchFacet] = useState("");

    const { data, error, loading } = useFetch(`${endpoints.AUTOCOMPLETE_FACETS}${queryStringConverter({ desc: typedFacet == "" ? " " : typedFacet, facet: facet, size: 10 })}`, JSON.stringify({ description, ...filters }), "POST")

    const [open, setOpen] = useState(false);

    const options = () => {
        if (data) {
            return data.map((d: any) => d.desc)
        } else {
            return [];
        }
    }

    useEffect(() => {
        if (typedFacet == "") {
            setOpen(true);
        }
    }, [typedSearchType])

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchFacet != "") {
                setTypedFacet(searchFacet);
            }
        }, 1500)

        return () => clearTimeout(delayDebounceFn)
    }, [searchFacet])

    const getQtd = (facet: string) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].desc == facet) {
                return data[i].total;
            }
        }
    }

    return (
        <Autocomplete
            options={options()}
            onInputChange={(event, newInputValue) => {
                setSearchFacet(newInputValue);
            }}
            onChange={(event: any, newValue: string | null) => {

                let achou = false;
                for (let i = 0; i < selectedRowsFacet.length; i++) {
                    if (selectedRowsFacet[i].id == newValue) {
                        achou = true;
                    }
                }

                if (newValue != null && achou == false) {
                    setSelectedRowsFacet([...selectedRowsFacet, { id: newValue, facet: facet, label: newValue, qtd: 0 }])
                }

                setSearchFacet("");
            }}

            inputValue={searchFacet}
            loading={loading}

            renderOption={(props, option) => (
                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={10}>
                            {option}

                        </Grid>
                        <Grid item xs={2}>
                            <Chip label={getQtd(option)} size='small' color='primary' sx={{ ml: 6 }} variant='outlined' />
                        </Grid>

                    </Grid>
                </Box>
            )}


            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Pesquise uma faceta"
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                />
            )}
        />);
}

export default SearchFacetInput;
